(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    
if (window.matchMedia('(min-width: 768px)').matches) {
$(document).ready(function() {
  let header = $('#shopify-section-header');
  let topBar = $('#shopify-section-announcement');
  let offSet = $(topBar).height() - 1;
  $(window).scroll(function(){
    if ($(this).scrollTop() > offSet) {
      $(header).addClass('fixed__header');
	  $('.header--bg').css('opacity', '1');
    } else {
      $(header).removeClass('fixed__header');
	  $('.header--bg').css('opacity', '0');
    }
  });
});
}

  } catch(e) { console.error(e); }
})();

})();
